import { startOfToday } from 'date-fns';

const getStandardBillingDeadline = () => startOfToday();

export default getStandardBillingDeadline;
